import { render } from "./CrProposersListModal.vue?vue&type=template&id=27afcf54"
import script from "./CrProposersListModal.vue?vue&type=script&lang=js"
export * from "./CrProposersListModal.vue?vue&type=script&lang=js"

import "./CrProposersListModal.vue?vue&type=style&index=0&id=27afcf54&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__